import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { TextField } from "@src/components/ui-kit";
import { observer } from "mobx-react-lite";
import type { TaskGroupTemplateCreateModalStore } from "./store";

type TaskGroupTemplateModalProps = {
  store: TaskGroupTemplateCreateModalStore;
};
export const TaskGroupTemplateModal = observer(function TaskGroupTemplateModal({
  store,
}: TaskGroupTemplateModalProps) {
  return (
    <Modal
      isOpen={store.disclosure.isOpen}
      onClose={store.disclosure.onClose}
      trapFocus={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text>
            <Trans>Task group template</Trans>
          </Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <TextField
            value={store.name.value}
            onChange={store.name.onChange}
            error={store.name.error}
            label={t`Name`}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            mr="2"
            colorScheme="grey"
            isLoading={store.mutator.isLoading.value}
            onClick={store.handleCancel}
            variant="ghost"
          >
            <Trans>Cancel</Trans>
          </Button>
          <Button
            isDisabled={store.name.hasError}
            isLoading={store.mutator.isLoading.value}
            onClick={store.handleConfirm}
          >
            <Trans>Create</Trans>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
});
